import { render } from "./camera.vue?vue&type=template&id=251bba76&scoped=true"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"

import "./camera.vue?vue&type=style&index=0&id=251bba76&scoped=true&lang=css"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251bba76"]])

export default __exports__